import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getStations: (state) =>  {
    return state.all
  }
}

const actions = {
  search ({ rootGetters, commit }, name) {
    api.searchStation(name, rootGetters['user/getLang'])
      .then((stations) => {
        commit('setStations', stations)
      })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setStations (state, stations) {
    state.all = stations
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
